// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
const useStylesForBottomMenuIconImage = makeThemedStyles(
  "BottomMenuIconImage",
  (theme) => ({
    BottomMenuIconImg: {
      width: "3.2em",
      height: "3.2em",
    },
  })
);
type ElementProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
>;
export const BottomMenuIconImage: React.FunctionComponent<ElementProps> = (
  props: ElementProps
) => {
  const styles = useStylesForBottomMenuIconImage();
  /* eslint-disable */
  return (
    <img
      {...props}
      style={{ ...(props?.style || {}), ...{} }}
      className={clsx(styles.BottomMenuIconImg)}
    />
  );
};
export default BottomMenuIconImage;
